<simple-notifications [options]="notificationOptions"></simple-notifications>
<nav class="navbar navbar-inverse">
  <div class="container">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" [class.collapsed]="collapsed"
              (click)="collapsed = !collapsed" aria-expanded="false" aria-controls="navbar">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" routerLink="/"><span>Fieldsale Wingman</span></a>
    </div>
    <div id="navbar" class="navbar-collapse collapse in" [@slideUpAndDown]="collapsed ? 'out' : 'in'">
      <ul class="nav navbar-nav">
        <li routerLinkActive="active"><a routerLink="/calendar" (click)="collapsed = true">
          <mat-icon class="middle">today</mat-icon>
          Calendar</a></li>
        <li routerLinkActive="active"><a routerLink="/customer" (click)="collapsed = true">
          <mat-icon class="middle">person</mat-icon>
          Kunden</a></li>
        <li routerLinkActive="active">
          <a routerLink="/map" (click)="collapsed = true">
            <mat-icon class="middle">map</mat-icon>
            Karte
          </a>
        </li>
        <li routerLinkActive="active">
          <a routerLink="/reports" (click)="collapsed = true">
            <mat-icon class="middle">assignment</mat-icon>
            Berichte
          </a>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li><a routerLink="/settings" routerLinkActive="active" (click)="collapsed = true">
          <mat-icon class="middle">settings</mat-icon>
          Settings</a></li>
        <li><a href="/login" (click)="logout()"><span class="glyphicon glyphicon-log-out"></span> Logout</a></li>
      </ul>
    </div>
  </div>
  <app-loading-bar></app-loading-bar>
</nav>
<div class="container" (click)="collapsed = true">
  <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/page/page.component.html